import { PlusIcon } from '@heroicons/react/24/outline';
import noop from 'lodash/noop';
import { useTranslation } from 'react-i18next';

import FieldsetContainer from '@/components/shared/FieldsetContainer';
import ConditionalRenderer from '@/components/ui/custom/ConditionalRenderer';
import { Button } from '@/components/ui/daisy';
import useToggle from '@/data/hook/useToggle';
import { bookType } from '@/models/Book';

import MaterialTypeSelector from './MaterialTypeSelector';

type MaterialAddSectionProps = {
  bookType: bookType;
};

export default function MaterialAddSection({
  bookType,
}: MaterialAddSectionProps) {
  const { t } = useTranslation('translation', {
    keyPrefix: 'courseLineForm.materialsTab',
  });
  const { isOpen, open, close } = useToggle();

  return (
    <>
      <ConditionalRenderer condition={isOpen}>
        <MaterialTypeSelector
          bookType={bookType}
          onCancel={close}
          onContinue={noop}
        />
      </ConditionalRenderer>
      <ConditionalRenderer condition={!isOpen}>
        <FieldsetContainer>
          <Button size="md" onClick={open} className="bg-base-300">
            <PlusIcon className="w-4 h-4" />
            {t('addMaterial')}
          </Button>
        </FieldsetContainer>
      </ConditionalRenderer>
    </>
  );
}
